import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export interface CountCollectionPointsResponse {
  status?: string;
  collection?: string;
  external_id?: string;
  point_count: number;
  detail?: string;
}

interface CountCollectionPointsProps {
  collectionId: string;
  externalId: string;
}

export const countCollectionPoints = async ({
  collectionId,
  externalId,
}: CountCollectionPointsProps): Promise<CountCollectionPointsResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<CountCollectionPointsResponse>({
    url: `/collections/${orgId}/${collectionId}/points/by-external-id/${externalId}/count`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return (response?.data ?? response) as CountCollectionPointsResponse;
};
